import { Icon } from "@fanduel/og-fe-library";
import { useState } from "react";
import Link from "@/components/link/Link";
import { AUTHOR_FEATURED_BET_CTA_CLICKED } from "@/constants/amplitude";
import { AuthorBet } from "@/graphql/gql/graphql";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import BetDisplay from "./BetDisplay";
import styles from "./featuredBet.module.scss";

interface FeaturedBetProps {
  featuredBet: AuthorBet;
  name: string;
}

export default function FeaturedBet({ featuredBet, name }: FeaturedBetProps) {
  const [tooltipVisibility, setTooltipVisibility] = useState(false);

  const { logAmplitudeEvent } = useAmplitude();

  if (!featuredBet.market?.props?.length) return null;
  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <h2 className={styles.title}>
          Featured Bet
          <Icon
            data-test-id="tooltip-button"
            iconName="icons.information"
            iconColor="colorBaseBlueLighten1"
            iconSize={17}
            onClick={() => {
              setTooltipVisibility((val) => !val);
            }}
          />
        </h2>
        {featuredBet.article ? (
          <Link
            next
            href={"/" + featuredBet.article.slug}
            onClick={() => {
              logAmplitudeEvent(AUTHOR_FEATURED_BET_CTA_CLICKED, {
                Author: name ?? "",
                "Link Text": "view_bet_in_article",
                Module: "featured_bets",
                "Link URL": "/" + featuredBet?.article?.slug,
              });
            }}
          >
            View bet in article{" "}
            <Icon
              iconName="arrows.right"
              iconColor="colorBaseBlueLighten1"
              iconSize={12}
            />
          </Link>
        ) : (
          ""
        )}
      </div>
      {tooltipVisibility ? (
        <div data-testid="tooltip-container" className={styles.tooltip}>
          <p>
            Here you will find today&apos;s featured bet chosen by the author.
          </p>
          <Icon
            iconName="icons.cross"
            iconSize={17}
            iconColor="colorBaseBlueDarken1"
            onClick={() => setTooltipVisibility(false)}
          />
        </div>
      ) : (
        ""
      )}
      {!featuredBet.article && featuredBet.description ? (
        <p className={styles.betDescription}>{featuredBet.description}</p>
      ) : (
        ""
      )}

      <BetDisplay
        bet={featuredBet.market}
        eventName={featuredBet.eventName ?? ""}
        name={name}
        sportName={featuredBet?.article?.sport?.name}
      />
    </div>
  );
}
